import { render, staticRenderFns } from "./Changepsw.vue?vue&type=template&id=1b32b3c3&scoped=true&"
import script from "./Changepsw.vue?vue&type=script&lang=js&"
export * from "./Changepsw.vue?vue&type=script&lang=js&"
import style0 from "./Changepsw.vue?vue&type=style&index=0&id=1b32b3c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b32b3c3",
  null
  
)

/* custom blocks */
import block0 from "./Changepsw.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports